import {DefaultMenubarProps} from './types'
import DefaultMenubarView from './DefaultMenubarView'
import React from 'react'

const DefaultMenubar = (props: DefaultMenubarProps): React.ReactElement => {
    const {
        name, routeParams,
    } = props

    const onClose = (): void => history.back()

    return (
        <DefaultMenubarView
            name={name}
            onClose={onClose}
            routeParams={routeParams}
        />
    )
}

export default DefaultMenubar
